<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Đề cương tài liệu" :link="[{ text: 'Đề cương tài liệu', href: '../teachingDoc' }]" />
      </div>
    </div>
    <div v-if="loading" class="loading-container">
      <v-progress-circular indeterminate size="40"></v-progress-circular>
    </div>
    <div v-else class="px-4">
      <v-card outlined class="pa-6 mx-0 mb-6 elevation-0">
        <FilterTreeGrade @onFilterChanged="getFile" />
      </v-card>
      <v-row no-gutters>
        <v-col cols="4" class="pr-6">
          <v-card outlined height="100%" class="elevation-0" style="background-color: #ffffff">
            <v-card-title> Học phần </v-card-title>
            <v-card-text>
              <TreeNoteDocCat
                class="pl-6"
                v-for="(folder, fIdx) in docCategories"
                :key="folder.id"
                :folder="folder"
                @setItem="setSelectedItemForTable"
                :class="{ 'mt-2': fIdx !== 0 }"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="8">
          <DocCatTable :item="selectedItem" @refresh="refreshDocumentTable" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { AcademicLevel } from '@/plugins/api'
import { mapActions, mapState } from 'vuex'

import TreeNoteDocCat from '../../components/basic/tree/TreeNoteDocCat.vue'
import DocCatTable from '../../components/basic/tree/DocCatTable.vue'
import FilterTreeGrade from '../../components/basic/tree/FilterTreeGrade.vue'

export default {
  components: {
    Breadcrumbs,
    TreeNoteDocCat,
    DocCatTable,
    FilterTreeGrade,
  },

  data() {
    return {
      loading: true,
      selectedCard: null,
      selectedItem: null,
      academicLevels: [],
    }
  },
  computed: {
    ...mapState({
      docCategories(state) {
        return state['docCategory'].docCategories
      },
      profile(state) {
        return state['auth'].profile
      },
    }),
  },
  methods: {
    ...mapActions({
      fetchTree: 'docCategory/fetchTree',
      fetchTeachings: 'teacherDoc/fetchTeachings',
      fetchDocument: 'gradeDocument/fetchDocument',
    }),
    setSelectedItemForTable(item) {
      this.selectedItem = item
    },
    async getFile(item) {
      await this.initializeTeachingsTree(item)
    },
    async refreshDocumentTable(item) {
      this.$loading.active = true
      try {
        await this.fetchDocument({ docCategory: item._id })
      } catch (error) {
        this.$alert.error('Không tải được tài liệu')
      } finally {
        this.$loading.active = false
      }
    },
    async initializeTeachingsTree(data) {
      this.isLoading = true
      try {
        await this.fetchTree(data)
      } catch (error) {
        console.error('Failed to fetch teachings data:', error)
      } finally {
        this.isLoading = false
      }
    },
    async toggleCard(cardType) {
      this.$loading.active = true
      await this.initializeTeachingsTree(cardType)
      this.selectedCard = this.selectedCard === cardType ? null : cardType
      this.$loading.active = false
    },
  },

  async mounted() {
    try {
      const acaLevels = await AcademicLevel.fetch({ status: 'active' })
      acaLevels.sort((a, b) => {
        const numberA = Number(a.title.slice(-1))
        const numberB = Number(b.title.slice(-1))
        return numberA - numberB
      })
      this.academicLevels = acaLevels || []
    } catch (error) {
      console.error('Error fetching academic levels:', error)
    } finally {
      this.loading = false
    }
  },
}
</script>

<style scoped>
.card-container {
  /* display: flex; */
  align-items: center;
  position: relative;
  width: 400px;
}

.card {
  transition: transform 0.3s ease;
  width: 500px;
}

.card-buttons {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  position: absolute;
  right: -30px;

  transition: opacity 0.3s ease;
}
.slide-enter-active,
.slide-leave-active {
  transition: opacity 0.3s;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
}
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>
